import { apiRequest } from "../../index";

export const addMenuItem = async (menuItemData) => {
  return apiRequest("/api/owner/hotel-management/menu", "POST", menuItemData, true);
};

export const updateMenuItem = async ({menuId, data}) => {
  return apiRequest(`/api/owner/hotel-management/menu/${menuId}`, "PUT", data, true);
};

export const deleteMenuItem = async (menuId) => {
  return apiRequest(`/api/owner/hotel-management/menu/${menuId}`, "DELETE");
};

export const getMenuItems = async (categoryId , page , limit) => {
  return apiRequest(`/api/owner/hotel-management/menu/${categoryId}?page=${page}&limit=${limit}`, "GET");
};

export const addMenucategory = async (menuItemData) => {
  return apiRequest("/api/owner/hotel-management/menu/category", "POST", menuItemData);
};

export const updateMenucategory = async (menuItemData) => {
  return apiRequest(`/api/owner/hotel-management/menu/category/${menuItemData.id}`, "PUT", menuItemData);
};

export const toggleCategoryStatus = async (id) => {
  return apiRequest(`/api/owner/hotel-management/menu/visibility/${id}`, "PUT");
};

export const deleteMenucategory = async (id) => {
  return apiRequest(`/api/owner/hotel-management/menu/category/${id}`, "DELETE");
};

export const getAllCategories = async (hotelId) => {
  return apiRequest(`/api/owner/hotel-management/menu/category/${hotelId}`, "GET");
};

